<div class="header" [class.padded]="padded">
  @if (title) {
    <app-title [title]="title" [size]="large ? 'large' : 'medium'" />
  }
  @if (action && large) {
    <app-button bgColor="secondary" size="default" [label]="action" (click)="actionClicked()" />
  } @else if (action) {
    <app-simple-button [bold]="true" color="tint" [label]="action" (click)="actionClicked()" />
  }
</div>
